import Vue from 'vue';
import {
    GETWXLOGIINFOU
} from '@/api/login'

Vue.prototype.WX_LOGIN = async function (url) {
    // // js判断是否是线上环境
    if (process.env.NODE_ENV === 'development') {
        console.log('当前环境是开发环境');
    } else {
        let data = await GETWXLOGIINFOU()
        if (data.code == -2) {
            let dqLink = ''
            if (url) {
                dqLink = url
            } else {
                dqLink = window.location.href
            }
            let encodedString = encodeURIComponent(dqLink);
            window.location.replace(
                "/apis/app/wechat/oauth/user?url=" + encodedString
            );
        }
    }
}
 

// 设置 Cookie
Vue.prototype.setCookie=function (name, value, days = 7) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));  // 设置过期时间
    const expires = "expires=" + date.toUTCString();
    document.cookie = `${name}=${value}; ${expires}; path=/`;
}

// 获取 Cookie
Vue.prototype.getCookie=function (name) {
    const nameEQ = name + "=";
    const cookies = document.cookie.split(';');

    for (let i = 0; i < cookies.length; i++) {
        let cookie = cookies[i].trim();
        if (cookie.indexOf(nameEQ) === 0) {
            return cookie.substring(nameEQ.length, cookie.length);
        }
    }
    return null;
}

// 删除 Cookie
Vue.prototype.deleteCookie=function (name) {
    document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/";
}

// // 使用示例：
// setCookie('userToken', 'abc123xyz', 7);  // 设置 Cookie
// console.log(getCookie('userToken'));  // 获取 Cookie
// deleteCookie('userToken');  // 删除 Cookie
